var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmpty = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_4417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 22.0978V32.1957C36 34.2937 34.3877 36 32.3789 36H15.6211C13.6388 36 12.0264 34.3217 12 32.2237C12 32.1957 12 32.1957 12 32.1677V22.0978C12 22.0699 12 22.0699 12 22.0419C12 21.986 12 21.93 12.0264 21.8741C12.0529 21.7902 12.0793 21.7342 12.1057 21.6503L16.5991 12.5594C16.7577 12.1958 17.1013 12 17.4713 12H30.5021C30.8722 12 31.1894 12.1958 31.3744 12.5594L35.8678 21.6503C35.8943 21.7062 35.9207 21.7902 35.9471 21.8741C36 21.93 36 22.0139 36 22.0978Z",
    fill: "url(#paint0_linear_43_4417)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_43_4417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 22.0978V33.2306C36 34.7692 34.837 35.9999 33.3568 35.9999H14.6432C13.1894 35.9999 12 34.7692 12 33.2306V22.0419C12 21.9859 12 21.93 12.0264 21.874H18.0528C18.9515 21.874 19.6916 22.6293 19.6916 23.6083C19.6916 24.0838 19.8766 24.5313 20.1674 24.839C20.4846 25.1747 20.8546 25.3425 21.3304 25.3425H26.696C27.5947 25.3425 28.3347 24.5873 28.3347 23.6083C28.3347 23.1328 28.5198 22.6852 28.8105 22.3775C29.1277 22.0419 29.4977 21.874 29.9471 21.874H35.9471C36 21.93 36 22.0139 36 22.0978Z",
    fill: "url(#paint1_linear_43_4417)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.2222 3.41223C34.0653 3.98437 33.4381 4.19242 32.8109 3.82833C32.1314 3.51626 31.661 3.25619 31.7655 2.73606C31.9223 2.21594 32.5496 2.16392 33.2813 2.11191C34.1699 2.00789 34.3268 2.84009 34.2222 3.41223Z",
    fill: "#DAE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1518 3.93229C29.4132 4.40041 30.145 4.71248 30.6677 4.24437C31.2427 3.72424 31.7131 3.36015 31.4517 2.84003C31.1904 2.37191 30.7722 2.52795 29.8836 2.63198C29.1518 2.78801 28.8383 3.41217 29.1518 3.93229Z",
    fill: "#DAE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4515 2.00797C31.8174 1.95595 32.1833 2.164 32.2878 2.47608C32.3401 2.58011 32.3923 2.73614 32.3923 2.84017C32.4969 3.56835 32.2355 4.1925 31.8174 4.24451C31.3469 4.34854 30.8765 3.82841 30.8242 3.15225C30.8242 2.94419 30.8242 2.84017 30.8242 2.68413C30.8765 2.32004 31.0856 2.05998 31.4515 2.00797C31.5037 2.00797 31.4515 2.00797 31.4515 2.00797Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5138 5C32.532 5.19841 32.5498 5.38976 32.567 5.5747L31.9686 5.63053C31.9513 5.44539 31.9335 5.25369 31.9153 5.05483L32.5138 5ZM32.6737 6.7202C32.7115 7.1338 32.7446 7.51429 32.7715 7.87173L32.1721 7.91675C32.1456 7.56406 32.1128 7.18728 32.0751 6.7749L32.6737 6.7202ZM32.8368 9.03258C32.8497 9.43274 32.8497 9.81661 32.8337 10.205L32.2332 10.1803C32.2485 9.80856 32.2485 9.4395 32.2361 9.05187L32.8368 9.03258ZM32.7382 11.3747C32.6944 11.7373 32.6363 12.1176 32.5621 12.5295L31.9706 12.4228C32.0431 12.0207 32.0993 11.652 32.1414 11.3027L32.7382 11.3747ZM25.0305 12.2296C25.2575 12.087 25.5063 11.99 25.762 11.9349L25.8885 12.5225C25.6993 12.5633 25.5196 12.6336 25.3583 12.7336C25.2058 12.8445 25.0749 12.9813 24.9666 13.1371L24.473 12.7941C24.6193 12.5837 24.8 12.3946 25.0151 12.24L25.0226 12.2346L25.0305 12.2296ZM27.9467 12.5046C27.7538 12.3262 27.5302 12.1855 27.2911 12.0834L27.055 12.6361C27.2378 12.7142 27.4037 12.82 27.5432 12.9501L27.5496 12.9561L27.5564 12.9617C27.7164 13.0944 27.8526 13.2444 27.9668 13.4075L28.4591 13.0626C28.3168 12.8595 28.1466 12.6714 27.9467 12.5046ZM32.3344 13.6674C32.2948 13.8497 32.2527 14.0384 32.2078 14.2343L32.2045 14.2486L32.1998 14.2626C32.1828 14.3136 32.1656 14.3653 32.1482 14.4174C32.0933 14.5822 32.0367 14.752 31.9775 14.9207L31.4104 14.7214C31.4679 14.5578 31.5223 14.3946 31.5768 14.2308C31.5929 14.1825 31.609 14.1342 31.6252 14.0857C31.6684 13.897 31.7089 13.7153 31.747 13.54L32.3344 13.6674ZM24.071 14.9672C24.0138 14.7245 23.9916 14.4721 24.0028 14.2212L24.6033 14.248C24.5943 14.4485 24.6126 14.6477 24.6576 14.8361L24.6597 14.8448L24.6613 14.8536C24.6889 15.0094 24.7278 15.1619 24.777 15.3103L24.2065 15.4995C24.1492 15.3268 24.1037 15.149 24.071 14.9672ZM29.0385 15.2071C29.0498 14.9606 29.0383 14.7106 29.0017 14.4632L29.0385 15.2071ZM30.9429 16.8303C31.1148 16.6469 31.2614 16.4457 31.3891 16.235L30.8751 15.9235C30.7639 16.1069 30.6403 16.275 30.4998 16.4241L30.4942 16.4301L30.4889 16.4364C30.3905 16.5529 30.2815 16.6619 30.1635 16.7626L30.5539 17.2197C30.6934 17.1005 30.8239 16.9706 30.9429 16.8303ZM25.4495 17.3139C25.1649 17.0782 24.9122 16.8017 24.7012 16.4941L25.1969 16.1541C25.3765 16.4159 25.5913 16.651 25.8329 16.851L25.4495 17.3139ZM28.1757 17.9261C28.0878 18.0903 28.004 18.2412 27.9229 18.3815L27.482 18.1269L27.478 18.1668C27.2933 18.1485 27.1105 18.1168 26.9321 18.071C26.7499 18.0257 26.5724 17.9661 26.4007 17.8936L26.6345 17.3399C26.7784 17.4006 26.9267 17.4503 27.0782 17.488L27.0804 17.4886L27.0804 17.4886C27.2282 17.5265 27.3811 17.5532 27.5373 17.5687L27.5043 17.9014C27.551 17.8179 27.5988 17.7302 27.6482 17.6379L27.6508 17.6332L27.6535 17.6285C27.7625 17.4411 27.864 17.2465 27.9553 17.0468L28.5019 17.2967C28.4028 17.5135 28.2932 17.7239 28.1757 17.9261ZM29.6214 17.8065C29.2883 17.9568 28.9343 18.0641 28.5748 18.1254L28.4738 17.5329C28.7836 17.48 29.0885 17.3875 29.3742 17.2586L29.6214 17.8065ZM27.3535 19.2731C27.1529 19.5563 26.9496 19.816 26.7215 20.1058L26.2491 19.7342C26.4779 19.4435 26.6723 19.1949 26.863 18.9257L27.3535 19.2731ZM26.0932 20.9155C25.9126 21.1539 25.7127 21.4243 25.4871 21.7404L24.9978 21.3913C25.2269 21.0702 25.4303 20.7952 25.614 20.5526L26.0932 20.9155ZM24.9031 22.5795C24.8109 22.7152 24.7151 22.8575 24.6154 23.007L24.1153 22.6736C24.216 22.5226 24.3128 22.3788 24.4061 22.2416L24.9031 22.5795Z",
    fill: "#ABB5CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_43_4417",
    x: -4,
    y: 5.87402,
    width: 56,
    height: 46.126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_4417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43_4417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_4417",
    x1: 24,
    y1: 12,
    x2: 24,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DDEA",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DDEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43_4417",
    x1: 23.9921,
    y1: 21.5473,
    x2: 23.9921,
    y2: 36.1521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#979FAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_4417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmpty);
export default ForwardRef;